import {
    FlightRequestActionTypes,
    REESTABLISH_REQUEST_SUCCESS,
    REESTABLISH_REQUEST_FAILURE,
    REESTABLISH_REQUEST_CLEAR,
    ReEstablishRequestState,
    REESTABLISH_FLIGHTS_REQUEST_CLEAR,
    REESTABLISH_FLIGHTS_REQUEST_FAILURE,
    REESTABLISH_FLIGHTS_REQUEST_SUCCESS,
    REESTABLISH_FLIGHTS_AFTER_REJECTION_SUCCESS,
    REESTABLISH_FLIGHTS_AFTER_REJECTION_FAILURE,
    REESTABLISH_FLIGHTS_AFTER_REJECTION_CLEAR
} from './types';

const flightsByFlightNuberInitState: ReEstablishRequestState = {
    data: {
        rpl: null,
        id: ''
    }
}

export function reEstablishRequest(state = flightsByFlightNuberInitState, action: FlightRequestActionTypes) {
    switch (action.type) {
        case REESTABLISH_REQUEST_SUCCESS:
            return action.payload;
        case REESTABLISH_REQUEST_FAILURE:
            return action.payload;
        case REESTABLISH_REQUEST_CLEAR:
            return action.payload;
        default:
            return state;
    }
}

export function reEstablishFlights(state = [], action: FlightRequestActionTypes) {
    switch (action.type) {
        case REESTABLISH_FLIGHTS_REQUEST_SUCCESS:
            return action.payload;
        case REESTABLISH_FLIGHTS_REQUEST_FAILURE:
            return action.payload;
        case REESTABLISH_FLIGHTS_REQUEST_CLEAR:
            return action.payload;
        default:
            return state;
    }
}

export function reEstablishFlightsAfterRejection(state = [], action: FlightRequestActionTypes) {
    switch (action.type) {
        case REESTABLISH_FLIGHTS_AFTER_REJECTION_SUCCESS:
            return action.payload;
        case REESTABLISH_FLIGHTS_AFTER_REJECTION_FAILURE:
            return action.payload;
        case REESTABLISH_FLIGHTS_AFTER_REJECTION_CLEAR:
            return action.payload;
        default:
            return state;
    }
}